import { DashboardColumn } from "../../models/app/Layout";

export const MOCK_COLUMNS: DashboardColumn[] = [
  {
    "id": 1,
    "position": 1,
    "container_width": "small"
  }, {
    "id": 2,
    "position": 2,
    "container_width": "large"
  }
]
